import { AxiosRequestConfig } from 'axios'
import fileDownload from 'js-file-download'

import { axiosAuth, axiosPublic } from '../../services/api/api'

import { headers } from './util'

export const initializeDescriptorTranslation = (descriptorUI: string) =>
    axiosAuth.put(
        'descriptors/translations/initialize/',
        {
            descriptorUI,
        },
        {
            headers,
        }
    )

export const fetchDescriptorTranslation = (key: string) =>
    axiosAuth.get(`translations/${key}`)

export const submitDescriptorTranslation = (
    key: string,
    values: object,
    status?: string
) =>
    axiosAuth.put(
        `descriptors/translations/${key}`,
        {
            ...values,
            status,
        },
        {
            headers,
        }
    )

export const reviewDescriptorTranslation = (
    descriptorUI: string,
    accepted: boolean,
    userKey?: string
) =>
    axiosAuth.put(
        `descriptors/translations/${descriptorUI}/review/`,
        {
            accepted,
            userKey,
        },
        {
            headers,
        }
    )

export const getDescriptor = (key: string) =>
    axiosPublic.get(`descriptors/${key}`)

const downloadMARC = (
    requestUrl: string,
    key: string,
    params: AxiosRequestConfig['params'],
    extension?: string
) => {
    axiosPublic
        .get(requestUrl, { params, responseType: 'blob' })
        .then((res) => res.data)
        .then((file) =>
            fileDownload(file, `${key}-MARC.${extension || params.format}`)
        )
        .catch((err) => new Error(err))
}

export const getMarcRecord = (
    requestUrl: string,
    params: AxiosRequestConfig['params']
) => {
    return axiosPublic
        .get(requestUrl, { params, responseType: 'blob' })
        .then((res) => res.data)
        .catch((err) => new Error(err))
}

export const getMARCQualifier = async (
    key: string,
    year: number,
    format = 'xml',
    extension?: string
) => downloadMARC(`marc/qualifiers/${key}`, key, { year, format }, extension)

export const getMARCDescriptor = async (
    key: string,
    year: number,
    format = 'xml',
    extension?: string
) => downloadMARC(`marc/descriptors/${key}`, key, { year, format }, extension)

export const getMARCExpandedQualifiersRelatedToDescriptor = async (
    key: string,
    year: number,
    format = 'xml',
    extension?: string
) => downloadMARC(`marc/expanded/${key}`, key, { year, format }, extension)

export const isDescriptorInLangCodePresent = (key: string, langCode: string) =>
    axiosPublic
        .head(`/descriptors/${key}-${langCode}`)
        .then(() => true)
        .catch((error) => {
            if (error.response.status === 404) {
                return false
            } else {
                new Error(error)
            }
        })
